import styled from 'styled-components';
import { FormField } from 'ui/formField';
import { InputText } from 'ui/inputs';
import { Tooltip } from 'ui/tooltip';
import { Toggle, TOGGLE_SIZES } from 'ui/toggle';
import { Body1Bold, Body2 } from 'ui/theme/typography';
import { pxToRem } from 'utils/convert';
import { ListTypeSelector } from './ListTypeSelector';

const InputSection = styled.div`
  margin-top: ${pxToRem(20)};
  margin-bottom: ${pxToRem(20)};
`;

const ToggleContainer = styled.div`
  display: flex;
  max-width: 100%;
  align-items: center;

  &.null {
    background-color: #ddd;
  }
`;

const StyledToggle = styled(Toggle)`
  margin-right: ${pxToRem(10)};
`;

interface Panel1Page {
  listName: string;
  updateListName: (value: string) => void;
  listDescription: string;
  updateListDescription: (value: string) => void;
  listType: string;
  updateListType: (value: string) => void;
  updateExistingUserOnly: boolean;
  updateUpdateExistingUserOnly: (value: boolean) => void;
  isBlankList: boolean;
  updateIsBlankList: (value: boolean) => void;
  triggerJourney: boolean;
  updateTriggerJourney: (value: boolean) => void;
}

export function Panel1Content({
  listName,
  updateListName,
  listDescription,
  updateListDescription,
  listType,
  updateListType,
  updateExistingUserOnly,
  updateUpdateExistingUserOnly,
  isBlankList,
  updateIsBlankList,
  triggerJourney,
  updateTriggerJourney,
}: Panel1Page) {
  return (
    <div>
      <InputSection>
        <Body1Bold>List name</Body1Bold>
        <InputText id="listName" value={listName} onChange={updateListName} isRequired={true} />
      </InputSection>

      <InputSection>
        <Body1Bold>List description (optional)</Body1Bold>
        <FormField restrictionText={`${140 - listDescription.length} characters or less`}>
          <InputText
            id="listDescription"
            placeholder="Your List Description"
            value={listDescription}
            onChange={updateListDescription}
            maxLength={140}
          />
        </FormField>
      </InputSection>

      <InputSection>
        <ListTypeSelector listType={listType} updateListType={updateListType} />
      </InputSection>

      <InputSection>
        <Body1Bold>Blank List?</Body1Bold>
        <ToggleContainer>
          <StyledToggle
            id="toggleButton"
            isActive={isBlankList}
            onClick={() => {
              updateIsBlankList(!isBlankList);
            }}
            size={TOGGLE_SIZES.LARGE}
          />
          <Body2>Create a blank list with no users</Body2>
        </ToggleContainer>
      </InputSection>

      <InputSection>
        <Body1Bold>Update existing users only?</Body1Bold>
        <ToggleContainer>
          <StyledToggle
            id="toggleButton"
            isActive={updateExistingUserOnly}
            onClick={() => {
              updateUpdateExistingUserOnly(!updateExistingUserOnly);
            }}
            size={TOGGLE_SIZES.LARGE}
          />
          <Body2>Only update users that already exist and ignore any new users.</Body2>
        </ToggleContainer>
      </InputSection>

      <InputSection>
        <Body1Bold>Trigger journeys from this list?</Body1Bold>
        <ToggleContainer>
          <StyledToggle
            id="toggleButton"
            isDisabled={isBlankList}
            isActive={(() => {
              if (isBlankList) return false;
              return triggerJourney;
            })()}
            onClick={() => {
              updateTriggerJourney(!triggerJourney);
            }}
            size={TOGGLE_SIZES.LARGE}
          />
          <Body2>
            <Tooltip
              tooltipContent="Uploaded users will enter all journeys triggered by Subscribed To List, Unsubscribed From List, and User Profile Updated events"
              isUnderlined
            >
              Send list membership & field change events to trigger journey
            </Tooltip>
          </Body2>
        </ToggleContainer>
      </InputSection>
    </div>
  );
}
